// Piezas compartidas por las cuatro pantallas que cargan insumos desde Excel
// (Agregar Venta / Cotizacion / Pedido / Embarque). Son funciones puras: no tocan
// el form ni el estado, solo arman los renglones para que cada pagina los pase a su
// recalcularInsumosEnBatch.

// Mismo criterio que el alta manual (onChangeInsumoProyecto): se toma el precio de
// la lista seleccionada y, si el cliente tiene un precio propio para ese insumo, ese
// manda. Se replica aqui en vez de inventar otro camino para que un renglon cargado
// por Excel entre con exactamente el mismo precio que si se hubiera elegido a mano.
export const precioDeListaParaInsumo = (insumo, precioId, usarPrecioCliente = true) => {
  const precio = insumo?.precios?.find(
    (valuePrecio) => valuePrecio.precioId?.toString() === precioId
  );
  let valor = precio ? precio.precio : 0;
  if (
    usarPrecioCliente &&
    insumo?.precioClienteAlternativo !== undefined &&
    insumo?.precioClienteAlternativo !== null
  ) {
    valor = insumo.precioClienteAlternativo;
  }
  return valor;
};

// Convierte lo que devuelve ModalCargarExcelInsumos en renglones del Form.List.
// `precioExcel` en null significa que el Excel no traia precio, no que valga cero.
export const construirFilasInsumosDesdeExcel = ({
  filas,
  proyectoId,
  precioId,
  usarPrecioCliente = true,
}) =>
  filas.map((f) => {
    const fila = {
      insumoId: f.insumo._id,
      proyectoId,
      cantidad: f.cantidad,
      precioUnitario:
        f.precioExcel === null || f.precioExcel === undefined
          ? precioDeListaParaInsumo(f.insumo, precioId, usarPrecioCliente)
          : f.precioExcel,
      descuento: f.descuento || 0,
    };
    if (f.leyenda) fila.leyenda = f.leyenda;
    if (f.observaciones) {
      fila.observaciones = f.observaciones;
      // Las observaciones que vienen del Excel salen en el PDF pero no viajan al
      // CFDI: observacionesXml es un opt-in de captura manual.
      fila.observacionesXml = false;
    }
    return fila;
  });

// Los insumos que aun no estan en el catalogo local (state.todasInsumos), para
// registrarlos de una sola vez en lugar de un setState por renglon.
export const insumosNuevosParaCatalogo = (filas, todasInsumos) => {
  const yaExistentes = new Set((todasInsumos || []).map((i) => i._id.toString()));
  const nuevos = [];
  filas.forEach((f) => {
    const id = f.insumo?._id?.toString();
    if (id && !yaExistentes.has(id)) {
      yaExistentes.add(id);
      nuevos.push(f.insumo);
    }
  });
  return nuevos;
};

// El modo lo elige el usuario en el modal: 'reemplazar' deja solo lo del Excel,
// 'agregar' lo pone despues de lo ya capturado.
export const combinarFilasInsumos = (insumosActuales, filasNuevas, modo) =>
  modo === "reemplazar" ? filasNuevas : [...(insumosActuales || []), ...filasNuevas];

// Payload de inventarios/inventarioInsumoProyectoBulk: una sola llamada para todos
// los renglones en vez de una por renglon.
export const payloadInventarioBulk = (filas, proyectoId) =>
  filas.map((f, index) => ({
    index,
    insumoId: f.insumo._id,
    proyectoId,
    inventariable: f.insumo.inventariable,
    noPrincipal: f.insumo.noPrincipal,
    insumoCompuesto: f.insumo.insumoCompuesto,
  }));

// Aplica la respuesta del bulk de inventario sobre los renglones ya armados.
// `desplazamiento` es el indice donde empiezan los renglones nuevos cuando se
// agregaron al final de los que ya habia.
export const aplicarInventarioBulk = (filasDestino, resultados, desplazamiento = 0) => {
  if (!Array.isArray(resultados)) return;
  resultados.forEach((resItem) => {
    const destino = filasDestino[desplazamiento + resItem.index];
    if (destino) {
      destino.cantidadProyecto = resItem.cantidad !== null ? resItem.cantidad : "No inventariable";
    }
  });
};
